import * as socketIO from "socket.io-client";
import * as settingsService from "../services/settings";

let socket: SocketIOClient.Socket | undefined;

const connect = (createNewSocket: boolean = false) =>
  new Promise<SocketIOClient.Socket>((resolve, reject) => {
    const settings = settingsService.getSettings();

    if (socket && !createNewSocket) {
      return resolve(socket);
    }

    if (!settings) {
      return reject(Error(`Settings could not be found for this device.`));
    }

    if (socket && createNewSocket) {
      socket.disconnect();
    }

    socket = socketIO(`/?deviceId=${settings.id}`, {
      path: "/device-tunnel"
    });

    socket.on("connect", () => {
      resolve(socket);
    });
  });

export default connect;



// WEBPACK FOOTER //
// ./src/socket.io/index.ts